import {
    END_TRANSMISSION,
    TRANSMISSION_TOTAL_PENDING,
    TRANSMISSION_STARTED,
    UPDATE_MAX_DISPLAYED_PENDING_TLE,
} from '../actions/types'

const maxDisplayedPendingTe = parseInt(window._env_.REACT_APP_MAX_DISPLAYED_PENDING_TRANSMISSION)

interface TransmissionStore {
    tlist: any
    current: any
    transSelected: boolean
    idSelected: any
    saved: any
    savedTime: any
    editorState: any
    noKeyStroke: number
    transState: any
    totalPending: number
    totalPendingMessageDisplayed: boolean
    transmissionIsStarted: boolean
    isLoadingTransmission: boolean
    maxDisplayedPendingTle: number
}

const INITIAL_STATE: TransmissionStore = {
    tlist: {},
    current: null,
    transSelected: false,
    idSelected: null,
    saved: null,
    savedTime: null,
    editorState: null,
    noKeyStroke: 0,
    transState: null,
    totalPending: 0,
    totalPendingMessageDisplayed: false,
    transmissionIsStarted: false,
    isLoadingTransmission: false,
    maxDisplayedPendingTle: maxDisplayedPendingTe,
}

export default (state = INITIAL_STATE, action: any): TransmissionStore => {
    let tlist = {}
    switch (action.type) {
        case UPDATE_MAX_DISPLAYED_PENDING_TLE:
            return {
                ...state,
                maxDisplayedPendingTle: action.payload.maxDisplayedPendingTle,
            }

        case END_TRANSMISSION:
            tlist = {}
            Object.assign(tlist, state.tlist)
            delete tlist[action.payload.transId]
            return {
                ...state,
                tlist,
                current: null,
                transSelected: false,
                transState: null,
                idSelected: null,
            }
        case TRANSMISSION_TOTAL_PENDING:
            return {
                ...state,
                totalPending: action.payload,
                totalPendingMessageDisplayed: action.payload > maxDisplayedPendingTe,
            }
        case TRANSMISSION_STARTED:
            return {
                ...state,
                transmissionIsStarted: action.payload,
            }
        default:
            return state
    }
}
